import styled from 'styled-components';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { spacing, colors, smallShadow } from 'ui/theme';
import { CardHeader } from './CardHeader';
import { LoadingRows } from './LoadingRows';

export const Wrapper = styled.div`
  border-radius: ${spacing.half};
  background-color: ${colors.backgroundPrimary};
  ${smallShadow};
`;

export const Body = styled.div`
  & > *:not(:first-child) {
    border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  }
`;

export const MessageTypesCardLoading = ({ messageMedium }: { messageMedium: SupportedMediums }) => (
  <Wrapper data-test={`${messageMedium}-message-type-content`}>
    <CardHeader messageMedium={messageMedium} />
    <Body>
      <LoadingRows />
    </Body>
  </Wrapper>
);
